import React from 'react';

import {
  Box,
  BoxProps,
  DynamicHtmlContent,
  Typography,
} from 'app/shared/components/atoms';

interface TextWithHeaderProps extends BoxProps {
  headerText?: string;
  bodyText?: string;
  textColor?: string;
  linkVariant?: 'primary' | 'secondary' | 'tertiary';
}

export const TextWithHeader: React.FC<
  React.PropsWithChildren<TextWithHeaderProps>
> = ({
  headerText,
  bodyText,
  textColor,
  backgroundColor,
  linkVariant = 'secondary',
  gap = 2,
  ...props
}) => {
  if (!(headerText && bodyText)) {
    return null;
  }

  return (
    <Box
      backgroundColor={backgroundColor}
      data-qaid="text-with-header"
      flexDirection="column"
      gap={gap}
      {...props}
    >
      <Typography
        as="div"
        fontSize="fontSize400"
        fontFamily="title"
        fontWeight="medium"
        color={textColor}
      >
        {headerText}
      </Typography>
      <Box>
        <DynamicHtmlContent
          color={textColor}
          linkVariant={linkVariant}
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />
      </Box>
    </Box>
  );
};
